import { Pivot, PivotItem } from '@fluentui/react';
import * as React from 'react';
import Documents from '../details/documents/Documents';
import Escalations from '../details/escalations/Escalations';
import History from '../details/history/History';
import NonprofitDetail from '../details/nonprofit/NonprofitDetail';

const enum PivotLinkFormat {
  tabs = 'tabs'
}

const enum PivotLinkSize {
  large = 'large'
}

const AdminViewSmall: React.FunctionComponent = () => (
  <section id="adminViewSmall">
    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
      <NonprofitDetail />
    </div>
    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
      <Pivot linkFormat={PivotLinkFormat.tabs} linkSize={PivotLinkSize.large}>
        <PivotItem headerText="History" itemIcon="History">
          <div className="tile-content">
            <History ignoreHeader={true} />
          </div>
        </PivotItem>
        <PivotItem headerText="Document" itemIcon="Document">
          <div className="tile-content">
            <Documents ignoreHeader={true} />
          </div>
        </PivotItem>
        <PivotItem headerText="Escalations" itemIcon="DoubleChevronUp8">
          <div className="tile-content">
            <Escalations ignoreHeader={true} />
          </div>
        </PivotItem>
      </Pivot>
    </div>
  </section>
);

export default AdminViewSmall;
